import { useCurrency, CURRENCIES } from "@/context/CurrencyContext";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

export default function CurrencyToggle() {
  const { code, setCurrency } = useCurrency();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="currency-toggle"
        className="hidden md:flex items-center gap-1.5 text-sm border border-foreground/20 px-3 py-1.5 hover:border-foreground transition-colors mono"
        title="Change currency"
      >
        <Globe className="w-3.5 h-3.5"/>
        <span data-testid="currency-code">{code}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none border-foreground/15 min-w-[160px]">
        {Object.values(CURRENCIES).map((c) => (
          <DropdownMenuItem
            key={c.code}
            data-testid={`currency-option-${c.code}`}
            onClick={() => setCurrency(c.code)}
            className="cursor-pointer mono text-xs flex items-center gap-2"
          >
            <span className="w-4">{code === c.code && <Check className="w-3.5 h-3.5"/>}</span>
            <span className="opacity-70">{c.symbol}</span>
            <span>{c.code}</span>
            {c.code === "INR" && <span className="ml-auto text-[10px] opacity-60">India</span>}
            {c.code === "USD" && <span className="ml-auto text-[10px] opacity-60">Global</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
